(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();



setTimeout(() => {

const recommendationScroller = document.querySelector('.ed-rec-products .product-list');

const recommendationCards = recommendationScroller.querySelectorAll('.product-block');

const recommendationCardWidth = recommendationCards[0].offsetWidth;

const recBtns = document.querySelectorAll('.ed-rec-products .recbtn');


for (const recBtn of recBtns) {
  recBtn.addEventListener('click', function(e) {
    if (this.id == 'rec-left') {
      recommendationScroller.style.scrollBehavior = 'smooth';
      recommendationScroller.scrollLeft -= recommendationCardWidth;
      recommendationScroller.style.scrollBehavior = 'unset';
    } else {
      recommendationScroller.style.scrollBehavior = 'smooth';
      recommendationScroller.scrollLeft += recommendationCardWidth;
      recommendationScroller.style.scrollBehavior = 'unset';
    }
  });
}
  
  }, 1000);






  } catch(e) { console.error(e); }
})();
})();
